import React, { useEffect, useState } from "react";
import { Button, Group, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import AccountingReportFilters from "./accounting/AccountingReportFilters";
import ProfitAndLossView from "./accounting/ProfitAndLossView";
import { defaultPeriodEndDate } from "./accounting/financialStatementsUtils";

const ReportProfitAndLoss = () => {
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [fiscalPeriodId, setFiscalPeriodId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);

  const load = async (overrides = {}) => {
    const effectiveStart = overrides.startDate ?? startDate;
    const effectiveEnd = overrides.endDate ?? endDate;

    setLoading(true);
    try {
      const query = {};
      if (fiscalPeriodId) query.fiscalPeriodId = fiscalPeriodId;
      if (effectiveStart) query.startDate = effectiveStart.toISOString();
      if (effectiveEnd) query.endDate = effectiveEnd.toISOString();
      const data = await api.Accounting.getProfitAndLoss(query);
      setReport(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!fiscalPeriodId) return;

    const initPeriod = async () => {
      setLoading(true);
      try {
        const period = await api.getById({
          apiEntity: "fiscalPeriod",
          id: fiscalPeriodId,
        });
        const periodStart = period?.startDate ? new Date(period.startDate) : null;
        const periodEnd = defaultPeriodEndDate(period?.endDate);
        setStartDate(periodStart);
        setEndDate(periodEnd);

        const query = { fiscalPeriodId };
        if (periodStart) query.startDate = periodStart.toISOString();
        if (periodEnd) query.endDate = periodEnd.toISOString();
        const data = await api.Accounting.getProfitAndLoss(query);
        setReport(data);
      } finally {
        setLoading(false);
      }
    };

    initPeriod();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fiscalPeriodId]);

  return (
    <div>
      <Text size="xs" color="dimmed" mb="xs">
        {t("Statement of Profit or Loss for the selected period.")}
      </Text>
      <AccountingReportFilters
        fiscalPeriodId={fiscalPeriodId}
        onFiscalPeriodChange={setFiscalPeriodId}
        showPnlDateRange
        pnlStartDate={startDate}
        onPnlStartDateChange={setStartDate}
        pnlEndDate={endDate}
        onPnlEndDateChange={setEndDate}
      />
      <Group mb="sm">
        <Button size="xs" onClick={() => load()} loading={loading}>
          {t("Run Report")}
        </Button>
      </Group>
      <ProfitAndLossView report={report} loading={loading} />
    </div>
  );
};

export default ReportProfitAndLoss;
